const SET_FETCH_STATUS = 'SET_FETCH_STATUS';

/**
 * @param {'loading' | 'complete'} payload
 */
export const setFetchStatus = (payload) => ({
  type: SET_FETCH_STATUS,
  payload,
});

export function fetchStatusReducer(state = 'idle', action) {
  switch (action.type) {
    case SET_FETCH_STATUS:
      return action.payload;
    default:
      return state;
  }
}
